import Vue from 'vue'
import ToastificationContent from '../@core/components/toastification/ToastificationContent.vue'

export function errorNotification(title = '', text) {
  Vue.$toast({
    component: ToastificationContent,
    position: 'top-right',
    props: {
      title,
      icon: 'AlertTriangleIcon',
      variant: 'danger',
      text,
    },
  })
}

export function successNotification(title = '', text) {
  Vue.$toast({
    component: ToastificationContent,
    position: 'top-right',
    props: {
      title,
      icon: 'CoffeeIcon',
      variant: 'success',
      text,
    },
  })
}
